import { ContainerBoxInterface } from '@peakconcepts/landingpage-kit'
import ctaButton from './ctaButton'

const itemDescriptionConfig = {
  fontSize: '18px',
  margin: {
    desktop: '0 0 30px',
    tablet: '0 0 30px',
    mobile: '0 0 30px'
  }
}
const itemIconConfig = {
  defaultCss: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    color: '#fff',
    width: '25px',
    height: '25px',
    backgroundColor: '#00305e',
    borderRadius: '50%'
  },
  icon: 'done',
  size: 2
}
const data: ContainerBoxInterface = {
  lazyConfig: { once: true, offset: 200 },
  defaultCss: {
    backgroundImage:
      "linear-gradient(rgba(21, 47, 70, 0.85), rgba(21, 47, 70, 0.85)), url('/images/immobilienmakler/example-house.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  containers: [
    {
      classNames: 'container',
      padding: {
        fullHd: '80px 0',
        widescreen: '80px 0',
        desktop: '80px 40px',
        tablet: '60px 40px',
        mobile: '40px 16px'
      },
      containers: [
        {
          type: 'text',
          config: {
            dark: true,
            margin: 0,
            size: 2,
            text: 'Exklusive Immobilien-Anfragen wie am Fließband',
            defaultCss: {
              textAlign: 'center'
            }
          }
        },
        {
          type: 'hr',
          config: {
            height: 4,
            width: '120px',
            defaultCss: {
              color: 'primary'
            },
            margin: {
              desktop: '30px auto 40px',
              tablet: '30px auto 40px',
              mobile: '30px auto 40px'
            }
          }
        },
        {
          type: 'text',
          config: {
            dark: true,
            margin: {
              desktop: '0 0 40px',
              tablet: '0 0 40px',
              mobile: '0 0 40px'
            },
            text:
              'Wir wissen, Sie haben schon genug zu tun.<br/> Deshalb erledigen wir die <b>KOMPLETTE Gewinnung von neuen Objekt-Anfragen für Sie!</b>',
            defaultCss: {
              textAlign: 'center'
            }
          }
        },
        {
          classNames: 'columns is-multiline',
          containers: [
            {
              classNames: 'column is-12-mobile is-12-tablet is-6-desktop',
              containers: [
                {
                  defaultCss: {
                    backgroundColor: 'white',
                    height: '100%'
                  },
                  padding: {
                    desktop: '30px',
                    tablet: '30px',
                    mobile: '30px 30px 10px 30px'
                  },
                  containers: [
                    {
                      type: 'text',
                      config: {
                        size: 4,
                        text: 'Das beinhaltet:',
                        margin: {
                          desktop: '0 0 50px',
                          tablet: '0 0 50px',
                          mobile: '0 0 40px'
                        },
                        defaultCss: {
                          textAlign: 'left'
                        }
                      }
                    },
                    {
                      type: 'textWithIcon',
                      config: {
                        descriptionConfig: {
                          text:
                            'Erstellung Ihrer eigenen digitalen Neukundengewinnungs-Maschine',
                          ...itemDescriptionConfig
                        },
                        iconConfig: {
                          ...itemIconConfig
                        }
                      }
                    },
                    {
                      type: 'textWithIcon',
                      config: {
                        descriptionConfig: {
                          text:
                            'Entwicklung und Betreuung Ihrer Online-Werbeanzeigen',
                          ...itemDescriptionConfig
                        },
                        iconConfig: {
                          ...itemIconConfig
                        }
                      }
                    },
                    {
                      type: 'textWithIcon',
                      config: {
                        descriptionConfig: {
                          text:
                            'Monatliche Analyse und Optimierung der Kampagnen',
                          ...itemDescriptionConfig
                        },
                        iconConfig: {
                          ...itemIconConfig
                        }
                      }
                    }
                  ]
                }
              ]
            },
            {
              classNames: 'column is-12-mobile is-12-tablet is-6-desktop',
              containers: [
                {
                  defaultCss: {
                    backgroundColor: 'white',
                    height: '100%'
                  },
                  padding: {
                    desktop: '30px',
                    tablet: '30px',
                    mobile: '30px 30px 10px 30px'
                  },
                  containers: [
                    {
                      type: 'text',
                      config: {
                        size: 4,
                        text: 'Und das Beste daran…',
                        margin: {
                          desktop: '0 0 50px',
                          tablet: '0 0 50px',
                          mobile: '0 0 40px'
                        },
                        defaultCss: {
                          textAlign: 'left'
                        }
                      }
                    },
                    {
                      type: 'textWithIcon',
                      config: {
                        descriptionConfig: {
                          text:
                            'Nur Sie alleine haben Zugriff auf Ihre Anfragen',
                          ...itemDescriptionConfig
                        },
                        iconConfig: {
                          ...itemIconConfig
                        }
                      }
                    },
                    {
                      type: 'textWithIcon',
                      config: {
                        descriptionConfig: {
                          text:
                            'Sie müssen keine unnötigen Provisionen an Leadportale abgeben',
                          ...itemDescriptionConfig
                        },
                        iconConfig: {
                          ...itemIconConfig
                        }
                      }
                    },
                    {
                      type: 'textWithIcon',
                      config: {
                        descriptionConfig: {
                          text:
                            'Sie brauchen KEINE technischen Voraussetzungen. Wir erledigen alles für Sie.',
                          ...itemDescriptionConfig
                        },
                        iconConfig: {
                          ...itemIconConfig
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          classNames: 'column is-12-mobile is-12-desktop pl-0 pr-0',
          containers: [
            {
              type: 'text',
              config: {
                defaultCss: {
                  color: '#fff'
                },
                margin: {
                  fullHd: '25px 220px 50px',
                  widescreen: '25px 220px 50px',
                  desktop: '25px 0 50px',
                  tablet: '25px 0 50px',
                  mobile: '25px 0 50px'
                },
                size: 4,
                text:
                  '➞ Das Einzige, was Sie tun müssen, ist anrufen, abschließen und sich über neue Aufträge freuen!'
              }
            },
            {
              type: 'cta',
              config: {
                dark: true,
                margin: {
                  desktop: '10px 0 10px',
                  tablet: '10px 0 0',
                  mobile: '10px 0 0'
                },
                ...ctaButton
              }
            }
          ]
        }
      ]
    }
  ]
}

export default data
